// eslint-disable-next-line import/no-anonymous-default-export
export default {
  translations: {
    insurance: 'Страховка',
    tourist_insurance: 'Туристическая страховка',
    step_1: 'Введите данные вашей поездки',
    step_2: 'Выберите лучшее предложение',
    step_3: 'Введите личные данные',
    step_4: 'Оплатите и получите полис на e-mail',
    date_from: 'Начало',
    date_to: 'Окончание',
    back_to: "Назад",
    where_to_go: 'Куда собираетесь?',
    when_to_go: 'Даты поездки',
    who_to_go: 'Количество туристов',
    select_country: 'Выберите страну',
    add_tourist: '+ Добавить еще туриста',
    tourist: 'Турист',
    delete: 'Удалить',
    birth_date: 'Дата рождения',
    all_insurance: 'Показать все предложения',
    rules: 'Правила',
    user_agreement: 'Положения и условия использования',
    user_policy: 'Политика обработки персональных данных',
    contacts: 'Контактные данные',
    social_networks: 'Соц.сети',
    company: 'Компания',
    insurance_summ: 'Страховая сумма',
    price: 'Стоимость',
    options: 'опции',
    covid_coverage:
      'Покрывает риски, связанные с лечением коронавирусной инфекции (COVID-19)	',
    buy_for: 'Купить за',
    details: 'Подробные условия',
    form_insurance: 'Оформление полиса',
    selected_country: 'Страна поездки',
    from: 'с',
    to: 'по',
    insurance_offer_notification:
      'Оформление полиса возможно только до начала поездки',
    insurance_price: 'Стоимость полиса',
    name: 'Имя*',
    surname: 'Фамилия*',
    idnp: 'IDNP*',
    passportNumber: 'Серия и номер загранпаспорта*',
    phoneNumber: 'Телефон',
    enter_idnp: 'Пример: 1236548962364258. Макс. 13 символов.',
    enter_passportNumber: 'Пример: B1256326',
    enter_phoneNumber: 'Пример: +373 (00) 00 00 00 ',
    rules_block_title:
      'Подтверждаю, что в момент покупки медицинской страховки СТРАХУЕМОЕ ЛИЦО:',
    rules_block_1: 'Имеет вид на жительство в Республике Молдова;',
    rules_block_2:
      'Не путешествует в страну, на территории которой имеет постоянное место жительства или гражданином которой он является;',
    rules_block_3:
      'До начала страхового периода не подвергалась страховым случаям, приведшимк ущербу здоровью (травмам, несчастным случаям и др.);',
    rules_block_4:
      'Не проходит и не собирается начинать в страховом периоде медицинское лечение;',
    rules_block_5:
      'Не злоупотребляет медикаментами и другими запрещенными препаратами;',
    rules_block_6:
      'Не намеревается путешествовать с целью участия в экстремальных видах спорта без спец. сертификата;',
    rules_block_7:
      'Не направляется в страны, путешествие в которые не рекомендовано Министерством Иностранных Дел',
    rules_block_8:
      'Я ознакомился/ознакомилась с Особыми условиями медицинского страхованиядля выезжающих за границу, которые являются неотъемлемой частью Договора страхования, я согласен/согласна с их положениями.',
    rules_block_9:
      'Страхователь не несет ответственность за страховые случаи, произошедшие до начала и после окончания страхового периода, указанного в контракте. Я проинформирован/проинформирована Страховщиком и согласен/согласна с тем, что если лицо/лица, подлежащие страхованию, на момент заключения договора находятся за границей, то страховая защита начинается по истечении 5 дней с момента его подписания/подтверждения.',
    rules_block_10:
      'При этом, как страхователь (застрахованное лицо, в зависимости от обстоятельств), выражаю свое согласие на обработку персональных данных, указанных в данном заявлении, Страховщиком/законным представителем в соответствии с положениями «О защите персональных данных», в том числе в случае расследования дела об ущербе и заявляю, что у меня есть согласие других лиц, подлежащих страхованию согласно этому заявлению, на предоставление их личных данных.',
    hide_rules: 'Скрыть текст	',
    show_rules: 'Показать полностью',
    continue: 'Продолжить',
    total: 'Итого',
    description_title: 'Что нужно знать о страховании путешествий?',
    description_1_title_blue: 'Зачем нужна',
    description_1_title: 'страховка для путешествий?',
    description_1_text1:
      'Страхование путешествий является добровольным видом страхования. Стоит отметить, что для пересечения границ многих стран, - полис туриста является обязательным условием. Полис страхования путешествий может защитить от множества непредвиденных обстоятельств во время поездки.',
    description_1_text2:
      'Эта защита закрепляется в специальном страховом документе полисе выезжающего за рубеж (полис ВЗР). Именно в нем закрепляются условия и размеры компенсации по определенным расходам застрахованному лицу при наступлении страхового случая.',
    description_2_title_blue: 'Какие риски ',
    description_2_title: 'включает туристическая страховка?',
    description_2_text1:
      'Базовый страховой полис покрывает только основные риски:',

    description_2_text2: 'экстренное амбулаторное и стационарное лечение',
    description_2_text3:
      'стоматологическую и хирургическую медицинскую помощь и связанные с ними транспортировку',
    description_2_text4: 'вызов врача',
    description_2_text5: 'оплату лекарств и расходов на лечение',
    description_2_text6: 'эвакуацию на родину по состоянию здоровья',
    description_2_text7:
      'Получить компенсацию в случае невыдачи визы, отмены рейса, потери багажа или спортивной травмы по стандартной страховке не получится. В таких ситуациях нужна расширенная туристическая страховка для выезда за границу.',
    description_3_title_blue: 'отказать в возмещении медицинских расходов?',
    description_3_title: 'Может ли страховая компания ',
    description_3_text1:
      'По полису не покрываются случаи, произошедшие по причине нахождения Застрахованного в состоянии алкогольного или наркотического опьянения, случаи, связанные с ведением и протеканием беременности (исключение составляет внематочная беременность), с психическими заболеваниями.',
    description_3_text2:
      'Не покрывается пластическая и восстановительная хирургия, протезирование. Полный список исключений - в Правилах страхования.',
    description_4_title_blue: 'наступлении страхового случая?',
    description_4_title: 'Что делать при ',
    description_4_text1:
      'Свяжитесь с оператором сервисной службы доступным способом. Все контакты указаны в полисе;',
    description_4_text2:
      'Назовите оператору номер вашего договора страхования выезжающих за рубеж и коротко опишите, какая помощь вам нужна. Специалист вызовет врача или назовет адрес ближайшей клиники',
    description_4_text3:
      'Строго следуйте указаниям оператора. Не оплачивайте счета самостоятельно: расходы по страховым случаям возместит страховая компания',
    description_4_text4:
      'Если вы обратились в клинику без звонка в сервисную службу, внимательно оjормляйте jинансовые документы. В течение 30 дней предоставьте подтверждение расходов в страховую компанию',
    description_4_text5:
      'Мы примем решение о компенсации затрат в течение нескольких дней после вашего обращения.',

    success_title: 'Приятной поездки!',
    success_desc:
      'Полис был отправлен на почту example@gmail.com В течение 5 минут вы получите полис в формате PDF-документа',
    success_button: 'Скачать страховой полис сейчас	',
    fail_title: 'Оплата не прошла',
    fail_desc:
      'Если не удается оплатить страховку, попробуйте еще раз или свяжитесь с вашим банком.	',
    fail_button: 'Попробовать еще раз',
    confirm_order: 'Подтверждение даннных',
    insuranse_info_send:
      'Полис оплачивается онлайн и мгновенно отправляется по электронной почте в формате PDF',
    confirm_personal:
      'Даю свое согласие на обработку моих персональных данных относительно их ',
    confirm_terms: 'условий использования и хранения',
    confirm_policy: 'политики конфиденциальности',
    on_site: ' сайта.',   
    and: ' и ',
    pay: 'Оплатить',
    assistans: 'Ассистанс',
    insurance_rules: 'Правила страхования',
    insurance_policy: 'Пример страхового полиса',
    ambulatory_treatment: 'Амбулаторное лечение',
    doctor_call: 'Вызов врача',
    phone_expenses: 'Расходы на телефон',
    transportation_to_doctor: 'Транспортировка к врачу или в больницу',
    emergency_dentistry: 'Экстренная стоматология',
    emergency_medical_care: 'Экстренная медицинская помощь',
    medicines: 'Медикаменты',
    accident: 'Несчастный случай',
    cover_covid_risks: 'Покрывает риски, связанные с лечением коронавирусной инфекции (COVID-19)',
    standard_options: 'Стандартные опции',
    expenses_for_person: 'Расходы на сопровождающее лицо ',
    date_picker_place_holder: 'дд/мм/гггг',
    enter_your_name: 'Укажите Имя как в паспорте',
    enter_your_surname: 'Укажите Фамилию как в паспорте',
    client_responsability: 'Клиент несет ответственность за правильность введенных данных. Все данные должны соответствовать паспортным данным. Иначе страховка будет аннулирована.',
    consumer_information: 'Информация для потребителей',
    terms_of_payment: 'Условия оплаты и проведения платежей',
    country: 'Страна проживания*',
    city: 'Город проживания*',
    work_days_hours: 'ПН - ПТ 9:00-18:00',
    lunch_break: 'Перерыв 13:00-14:00',
    juridical_address: 'Юридический адрес',  
  },
};
